import { useEffect } from "react"

const useScrollReveal = (selector = ".scroll-reveal", options = {}) => {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(selector))
    if (!elements.length) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed")
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -100px 0px",
        ...options,
      }
    )

    elements.forEach((element) => {
      observer.observe(element)
    })

    return () => observer.disconnect()
  }, [selector, options])
}

export default useScrollReveal
